import * as React from "react";
const SvgBorder1 = (props) => /* @__PURE__ */ React.createElement("svg", { width: 2e3, height: 1, viewBox: "0 0 2000 1", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { y: 0.696289, width: 2e3, height: 1, fill: "#DDDDDD" }));
export default SvgBorder1;
